export const GET_LOGIN_REQUEST = "GET_LOGIN_REQUEST"
export const GET_LOGIN_SUCCESS = "GET_LOGIN_SUCCESS"
export const GET_LOGIN_CLEAR = "GET_LOGIN_CLEAR"